import moment from "moment-timezone"
import voca from "voca"

const preposition = "at"
moment.locale("en", {
  calendar: {
    lastDay: "[Yesterday] LL [" + preposition + "] h:mm a",
    sameDay: "[Today] LL [" + preposition + "] h:mm a",
    nextDay: "[Tomorrow], LL [" + preposition + "] h:mm a",
    lastWeek: "LL [" + preposition + "] h:mm a",
    nextWeek: "LL [" + preposition + "] h:mm a",
    sameElse: "LL [" + preposition + "] h:mm a",
  },
})

export function fuzzyDate(date) {
  return date ? moment(date).calendar() : "-"
}

export function personNameFormal(person) {
  return voca.titleCase(
    `${person?.last_name ?? ""}, ${person?.first_name ?? ""} ${person?.middle_name ?? ""
    }`
  )
}

export function personNameFull(person) {
  return voca.titleCase(
    `${person?.first_name ?? ""} ${person?.middle_name ?? ""} ${person?.last_name ?? ""
    }`
  )
}

export function personNameShort(person) {
  return voca.titleCase(
    `${person?.first_name ?? ""} ${person?.middle_name ?? ""} ${person?.last_name ?? ""
    }`
  )
}

export function unslugify(slug) {
  const result = slug.replace(/\_/g, " ")
  return result.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
  })
}

export function formatAddressObject(location) {
  let locfmtArray = []
  switch (location?.type?.name) {
    case 'home':
      locfmtArray = [location?.number, location?.street_name, location?.address]
      break;
    case 'condo':
    case 'office':
      locfmtArray = [location?.name, location?.tower_name, location?.number, location?.street_name, location?.address]
      break;
    case 'hotel':
      locfmtArray = [location?.name, location?.number, location?.guest_name, location?.street_name, location?.address]
      break;
    default:
      locfmtArray = [
        location?.tower_name,
        location?.number,
        location?.address,
        location?.street_name,
        location?.city?.name,
        location?.area?.name,
      ]
      break;
  }
  return locfmtArray.filter((x) => x).join(", ")
}

export function filterNonNull(obj) {
  return Object.fromEntries(Object.entries(obj).filter(([k, v]) => !(v === null || v === undefined)));
};

export const fmtColor = (colorStr) => {
  if (!colorStr) return '#FFF'
  if (colorStr?.startsWith("#")) {
    return colorStr
  } else {
    return `#${colorStr}`
  }
}

export const oxfordComma = (arr) => {
  const array = arr??[]
  return array.length === 2
    ? array.join(' and ')
    : array.length > 2
      ? array
        .slice(0, array.length - 1)
        .concat(`and ${array.slice(-1)}`)
        .join(', ')
      : array.join(', ')
}